/*
 * Stone Fragrances — Barra de metas con regalos automáticos (reemplazo de UpCart)
 * - Lee /cart.js, calcula el subtotal EXCLUYENDO las líneas de regalo.
 * - Meta 1 >= $399  (39900) -> agrega Decant  (variant 43147173625919)
 * - Meta 2 >= $2,500 (250000) -> SOLO visual (envío gratis, regla real en Shopify)
 * - Meta 3 >= $4,999 (499900) -> agrega Roll-on (variant 43285885485119)
 * - Debounce + guard para evitar bucles de AJAX.
 * - Refresca el drawer con el mismo mecanismo del tema (secciones) sin re-publicar.
 */
(function () {
  'use strict';
  if (window.__stoneRewardsInit) return;
  window.__stoneRewardsInit = true;

  var CART_URL = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';

  var T1 = 39900;
  var T2 = 250000;
  var T3 = 499900;
  var THRESHOLDS = [T1, T2, T3];
  var GIFTS = [
    { key: 'decant', id: 43147173625919, threshold: T1 },
    { key: 'rollon', id: 43285885485119, threshold: T3 }
  ];
  var GIFT_IDS = GIFTS.map(function (g) { return g.id; });
  var SEG = 100 / THRESHOLDS.length;

  var state = { reconciling: false, pending: false, timer: null, lastSubtotal: 0, lastReached: null };
  var observer = null;
  var obsTimer = null;

  var REWARD_NAMES = ['un Decant gratis 🎁', 'Envío gratis 🚚', 'un Roll-On gratis 🎁'];

  /* ---------- cálculo ---------- */
  function isGiftItem(item) {
    if (GIFT_IDS.indexOf(item.id) !== -1) return true;
    if (item.properties && item.properties._stone_reward) return true;
    return false;
  }

  function qualifyingSubtotal(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (it) {
      if (!isGiftItem(it)) sum += it.final_line_price;
    });
    return sum;
  }

  function fillPercent(sub) {
    var fill = 0;
    for (var i = 0; i < THRESHOLDS.length; i++) {
      var prev = i === 0 ? 0 : THRESHOLDS[i - 1];
      var cur = THRESHOLDS[i];
      if (sub >= cur) { fill += SEG; }
      else if (sub > prev) { fill += ((sub - prev) / (cur - prev)) * SEG; break; }
      else { break; }
    }
    return Math.min(fill, 100);
  }

  function formatMoney(cents, bar) {
    var v = Math.ceil(cents / 100);
    var sep = String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = (bar && bar.getAttribute('data-money-format')) || '';
    if (fmt && (fmt.indexOf('amount') !== -1)) {
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, sep)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, sep)
        .replace(/\{\{\s*amount\s*\}\}/g, sep);
    }
    return '$' + sep;
  }

  function message(sub, bar) {
    if (sub >= T3) { return '🎉 ¡Lo lograste! Desbloqueaste Decant, envío gratis y roll-on.'; }
    if (sub >= T2) { return 'Agrega ' + formatMoney(T3 - sub, bar) + ' más y llévate un Roll-On GRATIS 🎁'; }
    if (sub >= T1) { return 'Agrega ' + formatMoney(T2 - sub, bar) + ' más y llévate Envío GRATIS 🚚'; }
    return 'Agrega ' + formatMoney(T1 - sub, bar) + ' más y llévate un Decant GRATIS 🎁';
  }

  /* ---------- celebración (confeti al desbloquear) ---------- */
  function reachedCount(sub) {
    var n = 0;
    for (var i = 0; i < THRESHOLDS.length; i++) { if (sub >= THRESHOLDS[i]) n++; }
    return n;
  }

  function injectCelebStyles() {
    if (document.getElementById('stone-celeb-styles')) return;
    var s = document.createElement('style');
    s.id = 'stone-celeb-styles';
    s.textContent =
      '.stone-reward-toast{position:fixed;top:88px;left:50%;transform:translate(-50%,-14px);' +
      'background:#111;color:#fff;padding:1rem 1.8rem;border-radius:100px;font-weight:700;' +
      'font-size:1.35rem;letter-spacing:.01em;z-index:2147483646;opacity:0;white-space:nowrap;' +
      'box-shadow:0 10px 30px rgba(0,0,0,.28);pointer-events:none;' +
      'transition:opacity .35s ease,transform .35s ease;}' +
      '.stone-reward-toast.is-in{opacity:1;transform:translate(-50%,0);}' +
      '@media (max-width:600px){.stone-reward-toast{font-size:1.2rem;max-width:90vw;white-space:normal;text-align:center;}}';
    document.head.appendChild(s);
  }

  function showToast(name) {
    injectCelebStyles();
    var t = document.createElement('div');
    t.className = 'stone-reward-toast';
    t.textContent = '🎉 ¡Desbloqueaste ' + name + '!';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 450);
    }, 2400);
  }

  function confettiBurst() {
    var prev = document.getElementById('stone-confetti');
    if (prev && prev.parentNode) prev.parentNode.removeChild(prev);
    var canvas = document.createElement('canvas');
    canvas.id = 'stone-confetti';
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483647;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var W = canvas.width = window.innerWidth;
    var H = canvas.height = window.innerHeight;
    var colors = ['#111111', '#e8c66b', '#25D366', '#ff5a5f', '#4a90d9', '#ffffff'];
    // Centrar el estallido sobre el cajón (o el centro si no está)
    var dr = document.querySelector('#CartDrawer .drawer__inner');
    var rect = dr ? dr.getBoundingClientRect() : null;
    var ox = rect ? (rect.left + rect.width / 2) : (W / 2);
    var oy = rect ? (rect.top + 60) : (H / 3);
    var parts = [];
    for (var i = 0; i < 120; i++) {
      var ang = Math.random() * Math.PI * 2;
      var spd = 4 + Math.random() * 9;
      parts.push({
        x: ox, y: oy,
        vx: Math.cos(ang) * spd,
        vy: Math.sin(ang) * spd - 4,
        g: 0.32 + Math.random() * 0.2,
        s: 5 + Math.random() * 6,
        rot: Math.random() * 6.28,
        vr: (Math.random() - 0.5) * 0.4,
        c: colors[i % colors.length]
      });
    }
    var start = null, DUR = 1800;
    function frame(t) {
      if (start === null) start = t;
      var el = t - start;
      ctx.clearRect(0, 0, W, H);
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        p.vy += p.g; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, 1 - el / DUR);
        ctx.fillStyle = p.c;
        ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6);
        ctx.restore();
      }
      if (el < DUR) { requestAnimationFrame(frame); }
      else if (canvas.parentNode) { canvas.parentNode.removeChild(canvas); }
    }
    requestAnimationFrame(frame);
  }

  function celebrate(name) {
    try { showToast(name); confettiBurst(); } catch (e) { /* noop */ }
  }

  function maybeCelebrate(sub) {
    var reached = reachedCount(sub);
    if (state.lastReached === null) { state.lastReached = reached; return; }
    if (reached > state.lastReached) {
      celebrate(REWARD_NAMES[reached - 1]);
      state.lastReached = reached;
    } else if (reached < state.lastReached) {
      state.lastReached = reached;
    }
  }

  /* ---------- timer de reserva (urgencia) ---------- */
  var timerInterval = null;
  function fmtTime(sec) {
    if (sec < 0) sec = 0;
    var m = Math.floor(sec / 60);
    var s = sec % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  function tickTimer() {
    var el = document.getElementById('stone-cart-timer');
    if (!el) return;
    var end = parseInt(sessionStorage.getItem('stoneTimerEnd') || '0', 10);
    var remaining = Math.round((end - Date.now()) / 1000);
    if (remaining < 0) remaining = 0;
    var val = el.querySelector('.stone-timer__val');
    pauseObserver(function () {
      if (val) val.textContent = fmtTime(remaining);
      if (remaining <= 60) el.classList.add('is-urgent');
      else el.classList.remove('is-urgent');
    });
  }
  function startTimer() {
    var el = document.getElementById('stone-cart-timer');
    if (!el) return;
    var secs = parseInt(el.getAttribute('data-seconds') || '900', 10);
    var end = parseInt(sessionStorage.getItem('stoneTimerEnd') || '0', 10);
    var now = Date.now();
    if (!end || end <= now) {
      end = now + secs * 1000;
      try { sessionStorage.setItem('stoneTimerEnd', String(end)); } catch (e) { /* noop */ }
    }
    tickTimer();
    if (timerInterval) return;
    timerInterval = setInterval(tickTimer, 1000);
  }

  /* ---------- upsell "Completa tu experiencia" ---------- */
  var upsellState = { forProduct: null, html: null, wired: false };

  function buildUpsellCard(p) {
    var v = null;
    for (var i = 0; i < (p.variants || []).length; i++) {
      if (p.variants[i].available) { v = p.variants[i]; break; }
    }
    if (!v) v = (p.variants || [])[0];
    if (!v) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var bar = document.getElementById('stone-rewards-bar');
    var price = formatMoney(v.price, bar);
    var name = String(p.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;');
    var url = p.url || ('/products/' + p.handle);
    return '<div class="stone-upsell__card">' +
      '<a href="' + url + '" tabindex="-1">' +
      (img ? '<img class="stone-upsell__img" src="' + img + '" alt="" loading="lazy">' : '<span class="stone-upsell__img"></span>') +
      '</a>' +
      '<div class="stone-upsell__name">' + name + '</div>' +
      '<div class="stone-upsell__price">' + price + '</div>' +
      '<button type="button" class="stone-upsell__add" data-variant-id="' + v.id + '">Agregar</button>' +
      '</div>';
  }

  function injectUpsell() {
    var host = document.getElementById('stone-cart-upsell');
    if (!host) return;
    var row = host.querySelector('.stone-upsell__row');
    if (!row) return;
    if (upsellState.html) { row.innerHTML = upsellState.html; host.hidden = false; }
    else { host.hidden = true; }
  }

  function refreshUpsell(cart) {
    var items = (cart && cart.items) || [];
    var real = items.filter(function (it) {
      return !isGiftItem(it) && String(it.variant_id) !== '42838918823999';
    });
    if (!real.length) { upsellState.forProduct = null; upsellState.html = null; return Promise.resolve(); }
    var pid = real[0].product_id;
    var inCart = {};
    items.forEach(function (it) { inCart[it.product_id] = true; });
    if (pid === upsellState.forProduct && upsellState.html != null) { return Promise.resolve(); }
    return fetch('/recommendations/products.json?product_id=' + pid + '&intent=related&limit=10', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data && data.products) || [];
        var cards = [];
        for (var i = 0; i < prods.length && cards.length < 6; i++) {
          var p = prods[i];
          if (inCart[p.id]) continue;
          var fv = p.variants && p.variants[0];
          if (fv && GIFT_IDS.indexOf(fv.id) !== -1) continue;
          var c = buildUpsellCard(p);
          if (c) cards.push(c);
        }
        upsellState.forProduct = pid;
        upsellState.html = cards.length ? cards.join('') : null;
      }).catch(function () { /* noop */ });
  }

  function wireUpsell() {
    if (upsellState.wired) return;
    upsellState.wired = true;
    document.addEventListener('click', function (e) {
      var btn = (e.target && e.target.closest) ? e.target.closest('.stone-upsell__add') : null;
      if (!btn) return;
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      btn.disabled = true;
      btn.textContent = 'Agregando…';
      fetch(CART_URL + '/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      }).then(function () { schedule(); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Agregar'; });
    });
  }

  /* ---------- pintado ---------- */
  function connectObserver() {
    var root = document.getElementById('CartDrawer');
    if (root && observer) observer.observe(root, { childList: true, subtree: true });
  }

  function pauseObserver(fn) {
    if (observer) observer.disconnect();
    try { fn(); } finally { connectObserver(); }
  }

  function renderBar(sub) {
    var bar = document.getElementById('stone-rewards-bar');
    if (!bar) return;
    var fill = bar.querySelector('.stone-rewards__fill');
    if (fill) fill.style.width = fillPercent(sub) + '%';
    var msg = bar.querySelector('.stone-rewards__msg');
    if (msg) msg.textContent = message(sub, bar);
    var markers = bar.querySelectorAll('.stone-rewards__marker');
    Array.prototype.forEach.call(markers, function (m, idx) {
      if (sub >= THRESHOLDS[idx]) m.classList.add('is-reached');
      else m.classList.remove('is-reached');
    });
    if (sub >= T3) bar.classList.add('is-complete');
    else bar.classList.remove('is-complete');
    var unlocked = bar.querySelector('.stone-rewards__unlocked');
    if (unlocked) {
      var uh = '';
      if (sub >= T1) uh += '<span class="stone-unlocked__item">🎁 Decant gratis ✓</span>';
      if (sub >= T2) uh += '<span class="stone-unlocked__item">🚚 Envío gratis ✓</span>';
      if (sub >= T3) uh += '<span class="stone-unlocked__item">🎁 Roll-On gratis ✓</span>';
      unlocked.innerHTML = uh;
    }
    maybeCelebrate(sub);
  }

  function decorate() {
    // Ocultar líneas de Decant, Roll-on y Seguro: siguen en la orden (nos llegan al surtir),
    // pero no se muestran en el carrito. El premio ya se ve como "✓ gratis" en la barra.
    var hideIds = [GIFTS[0].id, GIFTS[1].id, 42838918823999];
    hideIds.forEach(function (id) {
      var input = document.querySelector('cart-drawer-items input[data-quantity-variant-id="' + id + '"]');
      if (!input) return;
      var row = input.closest('.cart-item');
      if (row) row.style.display = 'none';
    });
  }

  function paint() {
    pauseObserver(function () {
      renderBar(state.lastSubtotal);
      decorate();
      injectUpsell();
    });
    startTimer();
  }

  /* ---------- red ---------- */
  function getCart() {
    return fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function cartWrite(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Stone-Reward': '1' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(url + ' -> ' + r.status + ' ' + t); });
      return r.json();
    });
  }

  function refreshDrawer() {
    return fetch(CART_URL + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var parser = new DOMParser();
        if (data['cart-drawer']) {
          var dhtml = parser.parseFromString(data['cart-drawer'], 'text/html');
          var srcInner = dhtml.querySelector('.drawer__inner');
          var tgtInner = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('.drawer__inner');
          if (srcInner && tgtInner) {
            pauseObserver(function () { tgtInner.innerHTML = srcInner.innerHTML; });
          } else {
            ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
              var target = document.querySelector(sel);
              var src = dhtml.querySelector(sel);
              if (target && src) target.replaceWith(src);
            });
          }
        }
        if (data['cart-icon-bubble']) {
          var bhtml = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var bt = document.querySelector('#cart-icon-bubble');
          var bs = bhtml.querySelector('.shopify-section') || (bhtml.body && bhtml.body.firstElementChild);
          if (bt && bs) bt.innerHTML = bs.innerHTML;
        }
      });
  }

  /* ---------- reconciliación ---------- */
  function reconcile() {
    if (state.reconciling) return Promise.resolve();
    state.reconciling = true;
    var changed = false;
    return getCart().then(function (cart) {
      var sub = qualifyingSubtotal(cart);
      state.lastSubtotal = sub;
      state.lastCart = cart;
      var chain = Promise.resolve();
      GIFTS.forEach(function (g) {
        chain = chain.then(function () {
          var line = (cart.items || []).filter(function (it) { return it.id === g.id; })[0];
          var should = sub >= g.threshold;
          if (should && !line) {
            changed = true;
            return cartWrite(CART_URL + '/add.js', { id: g.id, quantity: 1, properties: { _stone_reward: g.key } });
          }
          if (should && line && line.quantity !== 1) {
            changed = true;
            return cartWrite(CART_URL + '/change.js', { id: String(g.id), quantity: 1 });
          }
          if (!should && line) {
            changed = true;
            return cartWrite(CART_URL + '/change.js', { id: String(g.id), quantity: 0 });
          }
        });
      });
      return chain.then(function () {
        if (changed) {
          return getCart().then(function (fresh) {
            state.lastSubtotal = qualifyingSubtotal(fresh);
            state.lastCart = fresh;
            return refreshDrawer();
          });
        }
      });
    }).then(function () {
      return refreshUpsell(state.lastCart);
    }).then(function () {
      paint();
    }).catch(function (e) {
      console.error('[stone-rewards]', e);
    }).then(function () {
      state.reconciling = false;
      if (state.pending) { state.pending = false; schedule(); }
    });
  }

  function schedule() {
    if (state.reconciling) { state.pending = true; return; }
    if (state.timer) clearTimeout(state.timer);
    state.timer = setTimeout(function () { state.timer = null; reconcile(); }, 400);
  }

  /* ---------- eventos ---------- */
  function wire() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(); });
      }
    } catch (e) { /* noop */ }

    if (!window.__stoneFetchPatched) {
      window.__stoneFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var method = (init && init.method) || (input && input.method) || 'GET';
        var isSelf = !!(init && init.headers && (init.headers['X-Stone-Reward'] === '1'));
        var out = origFetch.apply(this, arguments);
        try {
          if (!isSelf &&
              /\/cart\/(add|change|update|clear)(\.js)?/.test(url) &&
              String(method).toUpperCase() === 'POST') {
            out.then(function () { schedule(); }).catch(function () {});
          }
        } catch (e) { /* noop */ }
        return out;
      };
    }

    document.addEventListener('cart:updated', function () { schedule(); });
    document.addEventListener('cartUpdated', function () { schedule(); });
  }

  function setupObserver() {
    var root = document.getElementById('CartDrawer');
    if (!root || observer) return;
    observer = new MutationObserver(function () {
      if (obsTimer) clearTimeout(obsTimer);
      obsTimer = setTimeout(function () { obsTimer = null; paint(); }, 60);
    });
    connectObserver();
  }

  /* ---------- init ---------- */
  function init() {
    var bar = document.getElementById('stone-rewards-bar');
    if (bar) {
      var s = parseInt(bar.getAttribute('data-initial-subtotal'), 10);
      state.lastSubtotal = isNaN(s) ? 0 : s;
    }
    setupObserver();
    wire();
    wireUpsell();
    reconcile();
    startTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
